import React, { useState, useEffect } from "react";
import SortCommand from "../SortCommand/SortCommand";
import SearchIcon from "../SearchIcon/SearchIcon";
import "../../Styles/globalStyle.css";
import ToolTip from "../../ToolTip/ToolTip";
import useSize from "../../../Hooks/useSize.js";
import ReactDOM from 'react-dom';
import useBuildStyle from "../../../Hooks/useBuildStyle";

export default function TextBox(props) {
  const [isDragOver, setDragover] = useState(false);
  const buildStyle = useBuildStyle();
  const [caretPosition, setCaretPosition] = useState(undefined);
  const [actualWidth, actualHeight] = useSize(props.style.width.value, props.style.height.value, props.data.id);
  //var caretPosition = undefined
  
  useEffect(() => {
    
    props.updateSize(props.data.id, actualWidth, actualHeight);
  }, [actualWidth,actualHeight]);

  useEffect(() => {
    
    setCaretPosition(undefined)
  }, [props.data.properties.text.caretPosition]);

  const onDropColumn = (e) => {
    e.stopPropagation();
    props.onDropColumn(e, props.data);
    setDragover(false);
  };

  const onDrag = (e, dragOver) => {
    if (dragOver !== isDragOver)
      setDragover(dragOver);
   
  };
  
  const getStyle = () => {
    var newStyle = buildStyle(props.style);

    newStyle["border"] = "none";
    newStyle["background"] = props.onlyLabel
      ? "transparent"
      : props.style.background.value;
    return newStyle;
  };

  const getInputWidth = () => {
    var inputWidth = props.style.width.value;
    const iconWidth = 13;
    if (props.sortable) {
      
      inputWidth = parseInt(inputWidth.slice(0, -2)) - iconWidth + "px";
    }

    if (props.filterable) {
      inputWidth = parseInt(inputWidth.slice(0, -2)) - iconWidth + "px";
    }

    return inputWidth;
  };
  
  const getBorder = (styleBorder) => {
    return isDragOver ? "1px dashed #1f79e1"
    : (props.errors) ? props.errors.border
    : props.onlyLabel  ? "none"
    : (props.isSelected) ? props.style.border.value
    : props.dataGridColumn ? "none"
    : styleBorder;
  };

  const getInputStyle = () => {
    return { 
      width: getInputWidth(),
      height: props.style.height.value,
      textAlign: props.style.textAlign.value,
      //maxLength: props.style.maxLength.value,
      fontSize: props.style.fontSize.value,
      fontFamily: props.style.fontFamily.value,
      color: props.style.color.value,
      visibility: props.style.visibility.value,
      borderLeft: getBorder(props.style.borderLeft.value),
      borderTop: getBorder(props.style.borderTop.value),
      borderRight: getBorder(props.style.borderRight.value),
      borderBottom: getBorder(props.style.borderBottom.value),
      borderTopLeftRadius: props.style.borderTopLeftRadius.value,
      borderTopRightRadius: props.style.borderTopRightRadius.value,
      borderBottomLeftRadius: props.style.borderBottomLeftRadius.value,
      borderBottomRightRadius: props.style.borderBottomRightRadius.value,
      background: props.onlyLabel
      ? "transparent"
      : props.style.background.value,
      useSelect: props.onlyLabel
      ? "none"
      : "auto",
    }
  };

  const getFormat = (number) => {
    const separatorSize = parseInt(props.data.properties.groupSize.value)
    if (!separatorSize) return number
    const  n = Math.floor(number.length/separatorSize) 
    const  firstPart = number.length % separatorSize
    
    var value = number.slice(0,firstPart)
    
    Array.from(Array(n).keys()).map(item => {
      const start = (item)*separatorSize + firstPart
      const end = start + separatorSize //+3
      
      if (value == "")
        value = `${number.slice(start, end)}`
      else
        value = `${value}${props.data.properties.groupSeparator.value}${number.slice(start, end)}`
    })
    
    return value
  };
  
  const onKeyUp = (e) => {
    const property = props.data.properties
    if (
        (
          property.masks.value != "" || (property.groupSeparator.value != "" && property.text.caretPosition)) 
          && e.target.selectionStart && caretPosition == undefined
       )
    {
      e.target.selectionStart = property.text.caretPosition 
      e.target.selectionEnd = property.text.caretPosition 
      
    }
    setCaretPosition(e.target.selectionStart)
  };
  
  const onKeyDown = (e) => {
    
    setCaretPosition(e.target.selectionStart)
    
  };
  const onClickInput = (e) => {
    
    setCaretPosition(e.target.selectionStart)
    
  };


  const getValue = () => {
    
    const isNumber = props.data.properties.validations.selectedValues.map(item => item.type).includes("NUMBER")
    var value = props.data.properties.text.value.toString()
    
    value = value.replaceAll(props.data.properties.prefix.value,"")
    value = value.replaceAll(props.data.properties.suffix.value,"")
    if (props.data.properties.masks.value != ""){
      value = props.data.properties.text.maskValue ? props.data.properties.text.maskValue : props.data.properties.masks.value
    }

    else if (value != "" && (isNumber && props.data.properties.groupSeparator.value != "")){
        var number = value
        var wholePart = value
        var decimalPart = ""
        if(props.data.properties.decimalSeparator.value != "") {
          number = value.split(props.data.properties.decimalSeparator.value)
          wholePart = number[0]
          decimalPart = number.length > 1 ? `${props.data.properties.decimalSeparator.value}${number[1]}` : ""
        }
        wholePart = wholePart.replaceAll(props.data.properties.groupSeparator.value,"")
        value = `${getFormat(wholePart)}${decimalPart}`
    }
    
    return `${props.data.properties.prefix.value}${value}${props.data.properties.suffix.value}`
  };
  
  return (
    <React.Fragment>
      <div
        draggable={props.draggable}
        onDragStart={(e) => props.onDragStart(e)}
        onDrop={(e) => props.onlyLabel && onDropColumn(e)}
        onDragOver={(e) => props.onlyLabel && onDrag(e, true)}
        onDragLeave={(e) => props.onlyLabel && onDrag(e, false)}
        onClick={(e) => props.onClick(e)}
        style={getStyle()}
        //onMouseOver={() => setIsShowToolTip(true)}
        id={props.data.id} > 
                
          <input
            type="text"
            //name={props.data.properties.text.value}
            value={getValue()}
            className="textBox"
            readOnly={props.data.properties.readOnly.value}
            style={getInputStyle()}
            onKeyUp={(e) => {onKeyUp(e)}}
            onClick={(e) => onClickInput(e)}
            onKeyDown={(e) => onKeyDown(e)}
            onChange={(e) => props.onChange(e, e.target.value)}
            onKeyPress={(e) => props.onKeyPress(e)}
            onBlur={(e) => props.onBlur(e)}
            onMouseLeave={(e) => props.onMouseLeave(e)}
            //onMouseOver={(e) => props.onMouseOver(e)}
            onMouseEnter={(e) => props.onMouseEnter(e)}
            onMouseDown={(e) => props.onMouseDown(e)}
            placeholder={props.data.properties.placeholder.value}
            maxLength={props.data.properties.maxLength.value}
          />
         
          <div style={{ paddingTop: "5px"}}>
            {props.onlyLabel && props.sortable && <SortCommand />}
            {props.filterable &&  <SearchIcon className= "svgSearchIcon" onClick = {(e) => props.onClickSearchIcon(e)} id = {"Filter" + props.data.id} width="13px" />}
          </div>
        </div>
        {props.errors && props.errors.isColumn && <input readOnly style={props.errors.styles} value={props.errors.value} />}
    </React.Fragment>
  );
}
